/**
 * Pages.FirebaseList.FirebaseConfig is often stored as a JS object literal string
 * (unquoted keys), not strict JSON. Match Dream/Baydin parse strategies.
 */
export function parseFirebaseConfig(value: unknown): Record<string, unknown> | null {
  if (!value) return null;

  if (typeof value === 'object' && value !== null && 'apiKey' in value) {
    return value as Record<string, unknown>;
  }

  if (typeof value !== 'string') return null;

  try {
    const parsed = JSON.parse(value) as Record<string, unknown>;
    if (parsed && typeof parsed === 'object' && 'apiKey' in parsed) return parsed;
  } catch {
    /* not JSON */
  }

  try {
    let s = value.trim();
    if (!s.startsWith('{')) s = `{${s}}`;
    s = s.replace(/,\s*}/g, '}');
    s = s.replace(/([{,]\s*)([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":');
    s = s.replace(/'([^'\\]*)'/g, '"$1"');
    const parsed = JSON.parse(s) as Record<string, unknown>;
    if (parsed && typeof parsed === 'object' && 'apiKey' in parsed) return parsed;
  } catch {
    /* not a simple JS literal */
  }

  try {
    const raw = value.trim();
    const hasBraces = raw.startsWith('{') && raw.endsWith('}');
    const body = hasBraces ? `return (${raw})` : `return ({${raw}})`;
    const result = new Function(body)() as Record<string, unknown>;
    if (result && typeof result === 'object' && 'apiKey' in result) return result;
  } catch {
    /* all strategies failed */
  }

  return null;
}
